// context/GlobalContext.js
import React, { createContext, useState, useContext } from 'react'

const GlobalContext = createContext()

export function GlobalProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('')

  function showLoading() { setIsLoading(true) }
  function hideLoading() { setIsLoading(false) }
  function showMessage(msg, type = 'success') { setMessage(msg); setMessageType(type) }
  function hideMessage() { setMessage(''); setMessageType('') }

  return (
    <GlobalContext.Provider value={{ isLoading, message, messageType, showLoading, hideLoading, showMessage, hideMessage }}>
      {children}
    </GlobalContext.Provider>
  )
}

export function useGlobal() { return useContext(GlobalContext) }